var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, } from 'react';
import { Container, Loader } from './solid-button-styles';
import { getDiameter } from '../../utils';
var SolidButton = forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.hoverEffect, hoverEffect = _b === void 0 ? true : _b, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c, _d = _a.loaderProps, loaderProps = _d === void 0 ? {} : _d, props = __rest(_a, ["children", "hoverEffect", "isLoading", "loaderProps"]);
    var radius = loaderProps.radius, restLoaderProps = __rest(loaderProps, ["radius"]);
    return (React.createElement(Container, __assign({ hoverEffect: hoverEffect }, props, { ref: ref }), isLoading ? React.createElement(Loader, __assign({ width: getDiameter(radius !== null && radius !== void 0 ? radius : '0.75rem') }, restLoaderProps)) : children));
});
SolidButton.displayName = 'SolidButton';
export default SolidButton;
